import { render, staticRenderFns } from "./OthersModle.vue?vue&type=template&id=2fa122e6&scoped=true&"
import script from "./OthersModle.vue?vue&type=script&lang=js&"
export * from "./OthersModle.vue?vue&type=script&lang=js&"
import style0 from "./OthersModle.vue?vue&type=style&index=0&id=2fa122e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa122e6",
  null
  
)

export default component.exports